import React from "react"
import SectionDivider from "../shared/section-divider"
import { useStaticQuery, graphql } from "gatsby"
import {
  OverlayStyle,
  ContentContainer,
  SectionTitle,
} from "./additional-features.style"
import FeatureGrid from "../../design-system/organisms/feature-grid"
import Grid from "../shared/grid"

export default function AdditionalFeatures() {
  const query = useStaticQuery(graphql`
    query {
      brandedIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Icons/branded_icon.svg"
        }
      ) {
        publicURL
      }
      integrationIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Icons/integration_icon.svg"
        }
      ) {
        publicURL
      }
      accessibleIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Icons/accessible_icon.svg"
        }
      ) {
        publicURL
      }
      analyticsIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Icons/analytics_icon.svg"
        }
      ) {
        publicURL
      }
      languagesIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Icons/languages_icon.svg"
        }
      ) {
        publicURL
      }
      promotionIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Responsive Web App/Icons/promotion_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const content = [
    {
      icon: query.brandedIcon.publicURL,
      title: "Branded Experience",
      text:
        "Mappedin’s Responsive Web App can be customized to match your branding and the rest of your website, ensuring a seamless experience for visitors.",
    },
    {
      icon: query.integrationIcon.publicURL,
      title: "Easy Integration",
      text:
        "The interactive map is easily embedded into your website, offering a quick way to have your venue maps up and running.",
    },
    {
      icon: query.accessibleIcon.publicURL,
      title: "Accessible To All",
      text:
        "The Web App includes accessibility filters and pathing, allowing users to navigate easier routes that prioritize elevators over stairs and escalators.",
    },
    {
      icon: query.promotionIcon.publicURL,
      title: "Advertising & Promotions",
      text:
        "The web solution includes the ability to showcase deals, promotions, and events occurring within venues. These fields are editable within the CMS to ensure the most up-to-date information is displayed.",
    },
    {
      icon: query.analyticsIcon.publicURL,
      title: "Insights & Analytics",
      text:
        "Gain a better understanding of what your visitors are looking for by tracking searches and location selections. These insights can lead to more informed business decisions at your property.",
    },
    {
      icon: query.languagesIcon.publicURL,
      title: "Multiple Languages",
      text:
        "Mappedin’s products have been deployed globally and we strive to support as many languages as possible. If we don’t have the language you need, we will add it.",
    },
  ]

  return (
    <>
      <SectionDivider />
      <Grid overlayStyle={OverlayStyle}>
        <SectionTitle>Additional Features</SectionTitle>
        <ContentContainer>
          <FeatureGrid items={content} />
        </ContentContainer>
      </Grid>
      <SectionDivider flip />
    </>
  )
}
